//Local imports
import AssetPopoverForm from "modules/Common/Components/AssetPopoverForm";

export const popoverContent = ({ cancelClickHandler, saveReminderClickHandler }) => {
  return (
    <div className="popover-asset-content-inner">
      <AssetPopoverForm
        cancelClickHandler={cancelClickHandler}
        saveReminderClickHandler={saveReminderClickHandler}
      />
    </div>
  );
};

export default popoverContent;
